import {
  PublicData,
} from "./types";
import api from "./axiosConfig";

const BASE_PATH = "portal";

const portalPublicService = {
  getPublicData: async (regionId: string) => {
    try {
      // TODO: remove the mock here
    //   return Promise.resolve({
    //     "organization": {
    //         "_id": "623b0d18df415daf0a7e9b42",
    //         "organizationName": "Perera and Sons (STAGING)",
    //         "organizationLogoImageUrl": "https://assets.loyaltybeta.cxforge.com/623b0d18df415daf0a7e9b42/images/f4d570af-78a4-4d86-a625-9b16a9b3bef4.jpg",
    //         "address": {
    //             "line1": "string",
    //             "line2": "string",
    //             "line3": "string",
    //             "city": "Colombo",
    //             "stateOrProvince": "Western",
    //             "zipOrPostcode": "string"
    //         },
    //         "configuration": {
    //             "baseCountryCurrencyCode": "LKR",
    //             "tierConfiguration": {
    //                 "tierCalculationWindow": 366
    //             }
    //         },
    //         "regions": [
    //             {
    //                 "_id": "623b0ff08d1b3e30481d7cb2",
    //                 "organizationId": "623b0d18df415daf0a7e9b42",
    //                 "regionName": "Sri Lanka",
    //                 "defaultCountryISO2Code": "LK",
    //                 "defaultCurrencyCode": "LKR",
    //                 "regionIconUrl": "https://assets.loyaltybeta.cxforge.com/images/dbd12f40-262c-11ee-95a0-9d4838471c8c.png"
    //             },
    //             {
    //                 "_id": "66d553e5c317597624a14c99",
    //                 "organizationId": "623b0d18df415daf0a7e9b42",
    //                 "regionName": "TEST R NEW",
    //                 "defaultCountryISO2Code": "LK",
    //                 "defaultCurrencyCode": "LKR",
    //                 "regionIconUrl": "https://assets.loyaltybeta.cxforge.com/623b0d18df415daf0a7e9b42/images/ade1a703-f182-4c78-a929-b9b97831603c.png"
    //             },
    //             {
    //                 "_id": "67403833e64f3a1aa3368d5d",
    //                 "organizationId": "623b0d18df415daf0a7e9b42",
    //                 "regionName": "Sri Lanka1",
    //                 "defaultCountryISO2Code": "LK",
    //                 "defaultCurrencyCode": "LKR",
    //                 "regionIconUrl": "string"
    //             },
    //             {
    //                 "_id": "67403878ce085cec200484ae",
    //                 "organizationId": "623b0d18df415daf0a7e9b42",
    //                 "regionName": "Sri Lanka2",
    //                 "defaultCountryISO2Code": "LK",
    //                 "defaultCurrencyCode": "LKR",
    //                 "regionIconUrl": "string"
    //             },
    //             {
    //                 "_id": "67403b5b58134cbf1326849a",
    //                 "organizationId": "623b0d18df415daf0a7e9b42",
    //                 "regionName": "Sri Lanka3",
    //                 "defaultCountryISO2Code": "LK",
    //                 "defaultCurrencyCode": "LKR",
    //                 "regionIconUrl": "string"
    //             },
    //             {
    //                 "_id": "67406be09035d5b38a333c79",
    //                 "organizationId": "623b0d18df415daf0a7e9b42",
    //                 "regionName": "Sri Lanka4",
    //                 "defaultCountryISO2Code": "LK",
    //                 "defaultCurrencyCode": "LKR",
    //                 "regionIconUrl": "string"
    //             },
    //             {
    //                 "_id": "67ad9b76755c3a8e24f641fc",
    //                 "organizationId": "623b0d18df415daf0a7e9b42",
    //                 "regionName": "Sri Lanka",
    //                 "defaultCountryISO2Code": "LK",
    //                 "defaultCurrencyCode": "LKR",
    //                 "regionIconUrl": "string"
    //             }
    //         ]
    //     },
    //     "region": {
    //         "_id": "623b0ff08d1b3e30481d7cb2",
    //         "regionName": "Sri Lanka",
    //         "defaultCountryISO2Code": "LK",
    //         "defaultCurrencyCode": "LKR",
    //         "regionIconUrl": "https://assets.loyaltybeta.cxforge.com/images/dbd12f40-262c-11ee-95a0-9d4838471c8c.png",
    //         "defaultMerchantId": "636e12f27f180000820008e2",
    //         "defaultMerchantLocationId": "623b0ff18d1b3e30481d7cb7",
    //         "pointConfiguration": {
    //             "minPointRedemptionAmount": 0,
    //             "maxPointRedemptionAmount": 1000000550000,
    //             "minPointsBalanceForRedemption": 100,
    //             "pointExpiryMethod": "FIXED",
    //             "pointExpiryStartMonth": 0,
    //             "pointExpiryEndMonth": 0,
    //             "pointExpiryPeriod": 10,
    //             "pointExpiryGracePeriod": 0,
    //             "currencyAmountPerPoint": 1.5,
    //             "regionalPointConversionRates": [],
    //             "jobEnabled": true,
    //             "jobFrequency": "0 0 1 * *",
    //             "pointExpiryCalculationJobFrequency": "0 0 1 1 *",
    //             "pointExpiryCalculationSubTransactionTypeIds": [
    //                 "623b0ff38d1b3e30481d7cd1",
    //                 "623b0ff48d1b3e30481d7cda",
    //                 "623b0ff48d1b3e30481d7ce0",
    //                 "623b0ff28d1b3e30481d7cc2",
    //                 "6539408ff68f6a5d24b24bf3",
    //                 "653a4af56953e0b350969740",
    //                 "653be95f6953e0b3509713ee",
    //                 "623b0ff28d1b3e30481d7cbf",
    //                 "623b0ff28d1b3e30481d7cc5",
    //                 "623b0ff38d1b3e30481d7cd4",
    //                 "623b0ff48d1b3e30481d7ce3",
    //                 "6401f27745b9a13e558a1c7b",
    //                 "653a45c96953e0b350969542",
    //                 "653a4a956953e0b35096973c",
    //                 "653a4c956953e0b350969748",
    //                 "653a4d096953e0b3509697a7",
    //                 "623b0ff38d1b3e30481d7cce",
    //                 "62a0e4e0ecf391744f380c92",
    //                 "623b0ff38d1b3e30481d7cd7",
    //                 "623b0ff48d1b3e30481d7cdd",
    //                 "623b0ff28d1b3e30481d7ccb",
    //                 "653a44986953e0b35096953a",
    //                 "653a45706953e0b35096953e",
    //                 "653a4cb66953e0b35096977c",
    //                 "653a4d2e6953e0b3509697ab",
    //                 "623b0ff28d1b3e30481d7cc8",
    //                 "623b0ff18d1b3e30481d7cbc",
    //                 "653a4a2a6953e0b350969738",
    //                 "653a4c6d6953e0b350969744",
    //                 "653a4cd66953e0b350969791",
    //                 "653a4cf06953e0b35096979b",
    //                 "653be9866953e0b3509713f2",
    //                 "66fe1aa2abba88df321175f7"
    //             ]
    //         },
    //         "supportInfo": {
    //             "phoneNumbers": [
    //                 "string"
    //             ],
    //             "email": "support@pereraandsons.com",
    //             "whatsappNumber": "string"
    //         }
    //     },
    //     "merchants": [
    //         {
    //             "_id": "636e12f27f180000820008e2",
    //             "merchantName": "Default Merchant",
    //             "type": "INTERNAL",
    //             "countryISO2Code": "LK",
    //             "createdOn": "2022-03-23T12:17:53.059Z",
    //             "pointRules": [],
    //             "id": "636e12f27f180000820008e2"
    //         },
    //         {
    //             "_id": "6538b6bb4d1f9085db0d535d",
    //             "merchantName": "Celeste Daily",
    //             "merchantLogoImageUrl": "https://assets.loyaltybeta.cxforge.com/623b0d18df415daf0a7e9b42/images/54c82cee-ed38-45e4-a5a8-52aac0bb75cb",
    //             "contact": {
    //                 "name": "K Super",
    //                 "mobileNumber": "94778845714",
    //                 "email": "ksuper@jkh.com",
    //                 "address": {
    //                     "line1": "No2, 6th Lane, Colombo 03",
    //                     "line2": "Colombo 03",
    //                     "city": "Colombo",
    //                     "stateOrProvince": "Western Province",
    //                     "zipOrPostcode": "00300"
    //                 }
    //             },
    //             "type": "INTERNAL",
    //             "countryISO2Code": "LK",
    //             "countryName": "Sri Lanka",
    //             "createdOn": "2023-10-25T06:33:31.201Z",
    //             "pointRules": [],
    //             "id": "6538b6bb4d1f9085db0d535d"
    //         }
    //     ],
    //     "locations": {
    //         "_id": "623c1f6f8d1b3e30481d9749",
    //         "locationName": "Grameenphone Center Jatrabari 6"
    //     },
    //     "pointRules": [
    //         {
    //             "_id": "678979e4958cdb2670084d1f",
    //             "merchantId": "636e12f27f180000820008e2",
    //             "name": "Customer Portal Sign Up Bonus",
    //             "description": "Customer earns 100 points for customer portal signups\n",
    //             "type": "NON_TRANSACTIONAL",
    //             "subType": "ENROLL",
    //             "ruleData": {
    //                 "daysOfWeek": [],
    //                 "points": 25,
    //                 "tierBasedAmountsPerPoint": [],
    //                 "pointAmountMappingsForRanges": [],
    //                 "pointAmountsForRangesEnabled": false
    //             },
    //             "status": "DISABLED",
    //             "ruleState": "INACTIVE",
    //             "merchant": {
    //                 "_id": "636e12f27f180000820008e2",
    //                 "merchantName": "Default Merchant",
    //                 "id": "636e12f27f180000820008e2"
    //             },
    //             "merchantLocation": null,
    //             "id": "678979e4958cdb2670084d1f"
    //         },
    //         {
    //             "_id": "679662a8b27f923df9e3f945",
    //             "merchantId": "636e12f27f180000820008e2",
    //             "name": "Enrol Loyalty Program",
    //             "description": "Customers earn 100 points at the loyalty program enrollment\n",
    //             "type": "NON_TRANSACTIONAL",
    //             "subType": "SIGNUP",
    //             "ruleData": {
    //                 "daysOfWeek": [],
    //                 "points": 250,
    //                 "tierBasedAmountsPerPoint": [],
    //                 "pointAmountMappingsForRanges": [],
    //                 "pointAmountsForRangesEnabled": false
    //             },
    //             "status": "ENABLED",
    //             "ruleState": "ACTIVE",
    //             "merchant": {
    //                 "_id": "636e12f27f180000820008e2",
    //                 "merchantName": "Default Merchant",
    //                 "id": "636e12f27f180000820008e2"
    //             },
    //             "merchantLocation": null,
    //             "id": "679662a8b27f923df9e3f945"
    //         },
    //         {
    //             "_id": "6799bd45276d7775b823996f",
    //             "merchantId": "636e12f27f180000820008e2",
    //             "name": "Spending Based Point Rule",
    //             "description": "-",
    //             "type": "TRANSACTIONAL",
    //             "subType": "GENERAL",
    //             "ruleData": {
    //                 "pointAmountsForRangesEnabled": true,
    //                 "pointAmountMappingsForRanges": [
    //                     {
    //                         "billValueMargin": 10000,
    //                         "amountPerPoint": 20
    //                     },
    //                     {
    //                         "billValueMargin": 5000,
    //                         "amountPerPoint": 50
    //                     },
    //                     {
    //                         "billValueMargin": 0,
    //                         "amountPerPoint": 100
    //                     }
    //                 ],
    //                 "daysOfWeek": [],
    //                 "tierBasedAmountsPerPoint": []
    //             },
    //             "status": "ENABLED",
    //             "ruleState": "ACTIVE",
    //             "merchant": {
    //                 "_id": "636e12f27f180000820008e2",
    //                 "merchantName": "Default Merchant",
    //                 "id": "636e12f27f180000820008e2"
    //             },
    //             "merchantLocation": null,
    //             "id": "6799bd45276d7775b823996f"
    //         },
    //         {
    //             "_id": "679a4a01276d7775b823a05e",
    //             "merchantId": "623b0ff18d1b3e30481d7cb5",
    //             "name": "TETS GEN adv",
    //             "description": "ADV",
    //             "type": "TRANSACTIONAL",
    //             "subType": "GENERAL",
    //             "ruleData": {
    //                 "amountPerPoint": 10,
    //                 "daysOfWeek": [],
    //                 "pointAmountMappingsForRanges": [],
    //                 "tierBasedAmountsPerPoint": [],
    //                 "pointAmountsForRangesEnabled": false
    //             },
    //             "status": "ENABLED",
    //             "ruleState": "ACTIVE",
    //             "merchant": {
    //                 "_id": "623b0ff18d1b3e30481d7cb5",
    //                 "merchantName": "Grameenphone",
    //                 "id": "623b0ff18d1b3e30481d7cb5"
    //             },
    //             "merchantLocation": null,
    //             "id": "679a4a01276d7775b823a05e"
    //         },
    //         {
    //             "_id": "679b4fbe69cee35594d94fe6",
    //             "merchantId": "6538b6bb4d1f9085db0d535d",
    //             "name": "Celeste General Spending",
    //             "description": "1",
    //             "type": "TRANSACTIONAL",
    //             "subType": "GENERAL",
    //             "ruleData": {
    //                 "amountPerPoint": 100,
    //                 "daysOfWeek": [],
    //                 "tierBasedAmountsPerPoint": [],
    //                 "pointAmountMappingsForRanges": [],
    //                 "pointAmountsForRangesEnabled": false
    //             },
    //             "status": "ENABLED",
    //             "ruleState": "ACTIVE",
    //             "merchant": {
    //                 "_id": "6538b6bb4d1f9085db0d535d",
    //                 "merchantName": "Celeste Daily",
    //                 "id": "6538b6bb4d1f9085db0d535d"
    //             },
    //             "merchantLocation": null,
    //             "id": "679b4fbe69cee35594d94fe6"
    //         },
    //         {
    //             "_id": "67a5e17cd543c8fac1aea50c",
    //             "merchantId": "6538b6bb4d1f9085db0d535d",
    //             "name": "Affinity Test",
    //             "description": "-",
    //             "type": "TRANSACTIONAL",
    //             "subType": "AFFINITY",
    //             "ruleData": {
    //                 "pointAmountsForRangesEnabled": true,
    //                 "affinityGroupId": "623b0ff08d1b3e30481d7cb3",
    //                 "isTierBased": true,
    //                 "daysOfWeek": [],
    //                 "tierBasedAmountsPerPoint": [
    //                     {
    //                         "tierId": "677fb7daeea6f66617588821",
    //                         "amountPerPoint": 100
    //                     },
    //                     {
    //                         "tierId": "678e0a1f79123b0e12d0f1df",
    //                         "amountPerPoint": 100
    //                     },
    //                     {
    //                         "tierId": "678e2a7f79123b0e12d0f2f4",
    //                         "amountPerPoint": 100
    //                     }
    //                 ],
    //                 "pointAmountMappingsForRanges": []
    //             },
    //             "status": "ENABLED",
    //             "ruleState": "ACTIVE",
    //             "merchant": {
    //                 "_id": "6538b6bb4d1f9085db0d535d",
    //                 "merchantName": "Celeste Daily",
    //                 "id": "6538b6bb4d1f9085db0d535d"
    //             },
    //             "merchantLocation": null,
    //             "id": "67a5e17cd543c8fac1aea50c"
    //         },
    //         {
    //             "_id": "67a5e3d0641629e20923c7c6",
    //             "merchantId": "6538b6bb4d1f9085db0d535d",
    //             "name": "Affinity Test",
    //             "description": "-",
    //             "type": "TRANSACTIONAL",
    //             "subType": "AFFINITY",
    //             "ruleData": {
    //                 "pointAmountsForRangesEnabled": false,
    //                 "affinityGroupId": "623b0ff08d1b3e30481d7cb3",
    //                 "isTierBased": true,
    //                 "daysOfWeek": [],
    //                 "tierBasedAmountsPerPoint": [
    //                     {
    //                         "tierId": "677fb7daeea6f66617588821",
    //                         "amountPerPoint": 100
    //                     },
    //                     {
    //                         "tierId": "678e0a1f79123b0e12d0f1df",
    //                         "amountPerPoint": 100
    //                     },
    //                     {
    //                         "tierId": "678e2a7f79123b0e12d0f2f4",
    //                         "amountPerPoint": 100
    //                     }
    //                 ],
    //                 "pointAmountMappingsForRanges": []
    //             },
    //             "status": "ENABLED",
    //             "ruleState": "ACTIVE",
    //             "merchant": {
    //                 "_id": "6538b6bb4d1f9085db0d535d",
    //                 "merchantName": "Celeste Daily",
    //                 "id": "6538b6bb4d1f9085db0d535d"
    //             },
    //             "merchantLocation": null,
    //             "id": "67a5e3d0641629e20923c7c6"
    //         }
    //     ],
    //     "tiers": [
    //         {
    //             "_id": "677fb7daeea6f66617588821",
    //             "name": "Bronze",
    //             "imageUrl": "https://assets.loyaltybeta.cxforge.com/623b0d18df415daf0a7e9b42/images/b833d148-d36b-4b05-a46e-35dbf4feebea.png",
    //             "benefits": [
    //                 "Eligible for priority customer service "
    //             ],
    //             "points": 0
    //         },
    //         {
    //             "_id": "678e0a1f79123b0e12d0f1df",
    //             "name": "Silver",
    //             "imageUrl": "https://assets.loyaltybeta.cxforge.com/623b0d18df415daf0a7e9b42/images/abe35a60-ff64-46ce-bbef-c4d85e22f56d.png",
    //             "benefits": [
    //                 "Chance to win a special Celeste seasonal hamper worth 50,000/- ",
    //                 "Eligible for priority customer service "
    //             ],
    //             "points": 300
    //         },
    //         {
    //             "_id": "678e2a7f79123b0e12d0f2f4",
    //             "name": "Gold",
    //             "imageUrl": "https://assets.loyaltybeta.cxforge.com/623b0d18df415daf0a7e9b42/images/22800821-7217-417b-8311-010c270d2ffe.png",
    //             "benefits": [
    //                 "Eligible for priority customer service.",
    //                 "Chance to win a high tea for two at a supreme hotel in Colombo."
    //             ],
    //             "points": 1500
    //         }
    //     ]
    // });
      const response = await api.get<PublicData>(`${BASE_PATH}/publicdata?regionId=${regionId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching public data:", error);
      throw error;
    }
  },
};

export default portalPublicService;
